const checkoutMixin = {
	inject: ['xcheckout'],
	computed: {
		checkout() {
			return this.xcheckout?.()
		},
	},
	methods: {
		async redirectAfterPurchase({ guestHash, orderId } = {}) {
			window.location.href = this.$router.resolve({
				name: 'user.order-detail',
				params: { id: orderId },
				query: guestHash ? { hash: guestHash } : {},
			}).href
		},
	},
}

export default checkoutMixin

